module.exports = __webpack_public_path__ + "static/media/emily-willis-lose.28ab2be1.jpg";